import * as React from "react";
import Svg, { Path } from "react-native-svg";

function GroupBuyIcon(props) {
  return (
    <Svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
      <Path
        d="M19.036 9.741a.565.565 0 000 .518l.777 1.526c.433.85.09 1.862-.78 2.306l-1.564.796a.589.589 0 00-.318.419l-.305 1.673c-.17.931-1.068 1.557-2.044 1.425l-1.753-.238a.627.627 0 00-.513.16l-1.273 1.18A1.852 1.852 0 0110 20c-.455 0-.909-.164-1.263-.493l-1.272-1.181a.627.627 0 00-.514-.16l-1.753.238a1.932 1.932 0 01-.26.017c-.87 0-1.629-.594-1.784-1.442l-.305-1.673a.589.589 0 00-.318-.42l-1.563-.795c-.871-.444-1.214-1.456-.781-2.306l.777-1.526a.565.565 0 000-.518L.187 8.215c-.433-.85-.09-1.862.78-2.305l1.564-.797a.589.589 0 00.318-.419l.305-1.673c.17-.931 1.068-1.557 2.044-1.425l1.753.238a.627.627 0 00.514-.16L8.737.494a1.864 1.864 0 012.526 0l1.273 1.18a.627.627 0 00.513.16l1.753-.238c.975-.132 1.873.494 2.044 1.425l.305 1.673c.033.18.149.334.318.42l1.563.795c.871.444 1.214 1.456.781 2.306l-.777 1.526z"
        fill="#E40046"
      />
      <Path
        d="M12.12 9.047c.881 0 1.587-.718 1.587-1.607 0-.89-.706-1.607-1.586-1.607-.88 0-1.591.718-1.591 1.607 0 .89.71 1.607 1.59 1.607zm-4.241 0c.88 0 1.585-.718 1.585-1.607 0-.89-.705-1.607-1.586-1.607-.88 0-1.59.718-1.59 1.607 0 .89.71 1.607 1.59 1.607zm0 1.071c-1.236 0-3.713.627-3.713 1.875v1.34h7.425v-1.34c0-1.248-2.477-1.875-3.712-1.875zm4.242 0c-.154 0-.329.011-.514.027.615.45 1.044 1.056 1.044 1.848v1.34h3.182v-1.34c0-1.248-2.476-1.875-3.712-1.875z"
        fill="#fff"
      />
    </Svg>
  );
}

export default GroupBuyIcon;
